import { render, staticRenderFns } from "./PayrollDataTable.vue?vue&type=template&id=91e73254&scoped=true&"
import script from "./PayrollDataTable.vue?vue&type=script&lang=js&"
export * from "./PayrollDataTable.vue?vue&type=script&lang=js&"
import style0 from "./PayrollDataTable.vue?vue&type=style&index=0&id=91e73254&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91e73254",
  null
  
)

export default component.exports